import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import InfoCard from '../info-card/PersonInfoCard'
import MeaningBody from './MeaningBody'

export default function NameMeaningCard({ meanings, ...props }) {
  const [t] = useTranslation()

  return (
    <InfoCard heading={t('info-cards.name-meaning.header')} {...props}>
      <MeaningBody meanings={meanings} />
    </InfoCard>
  )
}

// Stryker disable all
NameMeaningCard.propTypes = {
  /** Object with available name meanings. */
  meanings: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      meanings: PropTypes.array.isRequired,
    })
  ),
}
